// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const HistoryIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 200 200">
          <path d="M45.714 99.37c-.008-.148-.013-.297-.02-.446-1.568-40.165 32.77-70.02 68.05-70.02 35.282 0 68.952 27.804 68.952 70.02 0 19.533-9.07 37.888-21.03 49.64-13.886 13.647-31.856 19.15-47 19.15-28.19 0-47.72-19.923-47.72-19.923l-12.55 11.8s12.676 11.257 23.1 16.08c10.424 4.823 13.474 7.744 36.252 8.252 19.565.436 37.825-8.304 49.7-16.207 33.423-22.243 36.018-54.013 36.018-68.57 0-14.557-2.903-43.13-30.734-66.743-13.02-11.045-29.95-19.8-56.593-19.8-24.847 0-43.745 11.44-56.07 22.183-29.152 25.408-27.965 64.36-27.965 64.36l.107.225H.104l37.867 39.082L77.064 99.37H45.71z"/>
          <path d="M106.02 62.974v45.66l40.578 24.646 6.9-9.606-34.118-20.67V62.978h-13.36z"/>
        </svg>
      )
    }
  </Icon>
);

export default HistoryIcon;
